import { useQuery } from "@tanstack/react-query";
import { getValueItems } from "../../api/apiValueItems";
import i18next from "i18next";

export function useGetValueItems(params = {}) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["value-items", params, i18next.language],
        queryFn: () => getValueItems(params),
        retry: false,
    });

    const items = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, items, meta, refetch };
}
